module.exports = __webpack_public_path__ + "img/newLogo.0eda109d.svg";